import { render, staticRenderFns } from "./ConfirmAtivarDeleteCampanhaModal.vue?vue&type=template&id=1cf8d12f&"
import script from "./ConfirmAtivarDeleteCampanhaModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmAtivarDeleteCampanhaModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports